import { createContext, useContext } from 'react';

export type ContentWidths = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  xxl: number;
};

export const maxContentWidths = {
  xs: 100, // vw
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1536,
  xxl: 1920,
};
const contentWidthsContext = createContext(maxContentWidths);

type ContentWidthsProviderProps = {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xxl?: number;
  children: React.ReactNode;
};

const ContentWidthsProvider = ({
  xs = maxContentWidths.xs,
  sm = maxContentWidths.sm,
  md = maxContentWidths.md,
  lg = maxContentWidths.lg,
  xl = maxContentWidths.xl,
  xxl = maxContentWidths.xxl,
  children,
}: ContentWidthsProviderProps) => {
  return <contentWidthsContext.Provider value={{ xs, sm, md, lg, xl, xxl }}>{children}</contentWidthsContext.Provider>;
};

const useContentWidths = () => {
  const widths = useContext(contentWidthsContext);
  return widths;
};

export default contentWidthsContext;
export { ContentWidthsProvider, useContentWidths };
